const THUMBS_UP = '1f44d';
const CLAP = '1f44f';
const TADA = '1f389';
export const defaultEmojis: string[] = [THUMBS_UP, CLAP, TADA];

const HEART = '2764';
const FIRE = '1f525';
const RAISED_HANDS = '1f64c';
// The empty-state quick-react set shown in the footer reaction row — 5 emojis, distinct from the
// 3-emoji `defaultEmojis` set and the 6-emoji set used elsewhere.
export const footerReactionsDefaultEmojis: string[] = [HEART, THUMBS_UP, FIRE, CLAP, RAISED_HANDS];
